import { render, staticRenderFns } from "./FacilityList.vue?vue&type=template&id=b5365520"
import script from "./FacilityList.vue?vue&type=script&lang=js"
export * from "./FacilityList.vue?vue&type=script&lang=js"
import style0 from "./FacilityList.vue?vue&type=style&index=0&id=b5365520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports